import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { CommunityList } from '../components';
import { CommunityRow } from '../components/list/row';
import { observer } from 'mobx-react';
import useTypeStore from '../../../hooks/useTypeStore';
import useUsersStore from '../../../hooks/useUsersStore';
import Pagination from '../../../components/pagination';
import NoneContent from '../../../components/noneContent';
import SportsLoader from '../../../components/sportsLoader';

import Seo from '../../../components/seo';
import BannerGA from '../../../components/banner/BannerGA';
import './basic.css';

const Basic = observer(() => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get('page')) || 1;
  let type = location.pathname.replace('/community/', '');

  const pathname = location.pathname;
  let fromTrustedSite = false;
  if (pathname.startsWith('/trusted_site/review')) {
    type = 'park';
  } else if (pathname.startsWith('/trusted_site/board') || pathname.startsWith('/community/verification')) {
    type = 'verification';
    fromTrustedSite = true;
  }

  const communityStore = useTypeStore('communityStore');
  const userStore = useUsersStore();

  useEffect(() => {
    communityStore.actionList({ type, page });
  }, [page]);


  useEffect(() => {
    if (communityStore.shouldRefetch) {
      communityStore.actionList({ type, page });

      communityStore.shouldRefetch = false;
    }
  }, [communityStore.shouldRefetch]);

  const totalCount = communityStore.totalCount;
  const history = useHistory();
  const totalPage = Math.ceil(totalCount / 20) || 1;
  useEffect(() => {
    if (!communityStore.loading && totalCount > 0 && page > totalPage) {
      query.set('page', totalPage);
      history.replace(`${location.pathname}?${query.toString()}`);
    }
  }, [communityStore.loading, totalCount, page, totalPage, history, location.pathname, query]);

  const typeMap = {
    free: '자유',
    humor: '유머',
    //   trade: '모의투자',
    sports_analysis: '분석',
    park: '미니게임',
    verification: '보증게시판',
    crime: '피해공유',
    //   betble: '벳블공유'
  };
  return (
    <>
      <Seo title={`커뮤니티 ${typeMap[type]}`} />
      {type === 'verification' ? (
        <div className='page-description'>
          <div id='description-title'>네임드 보증 게시판 이용 안내</div>
          <ul id='description'>
            <li>보증게시판은 네임드가 보증하고 10억이상의 보증금을 예치한 업체의 이벤트와 홍보를 위한 게시판입니다.</li>
            <li>일반 회원분들 또한 자유롭게 글을 작성할 수 있습니다.</li>
            <li className={'underline'}>
              단, 네임드 보증업체가 아닌 업체의 홍보글은 삭제 및 영구 차단 등의 제재 대상이 됩니다
            </li>
          </ul>
        </div>
      ) : null}
      <div className='board_wrap'>
        {communityStore.loading ? (
          <SportsLoader />
        ) : totalCount < 1 && (fromTrustedSite && (!communityStore.boardNotice || communityStore.boardNotice.length === 0)) ? (
          <NoneContent title={'게시글'} />
        ) : (
          <div className='board_list'>
            {fromTrustedSite && communityStore.boardNotice && communityStore.boardNotice.length > 0 && (
              <div className='list_area'>
                {communityStore.boardNotice.map((item) => (
                  <CommunityRow
                    key={`${item.wr_id}-notice`}
                    item={item}
                    page={page}
                    category={type}
                    isAdmin={userStore.data.is_admin}
                    fromTrustedSite={fromTrustedSite}
                    isBoardNotice={true}
                  />
                ))}
              </div>
            )}
            {totalCount > 0 && (
              <>
                <CommunityList items={communityStore.items} />
                <Pagination page={page} totalCount={totalCount} rowCount={20} />
              </>
            )}
          </div>
        )}
      </div>

      {/* NEW ADS #2 */}
      {type !== 'sports_analysis' && (
        <BannerGA
          containerStyle={{
            display: 'block',
            width: 450,
            height: 50,
            marginTop: 16,
          }}
          gaSlot={'5003058707'}
          width={450}
          height={50}
        />
      )}
    </>
  );
});

export default Basic;
